import { Component } from 'react';
import { SUPPORTED_MR_FORMATS } from './MedicalRecordsRightPanel';

interface Props {
    fileUploadId: string;
    onRefChange: (ref: HTMLInputElement | null) => void;
    onFilesSelect: (e: Event) => void;
}

class MRFileSelector extends Component<Props> {
    componentDidMount(): void {
        document
            .getElementById(this.props.fileUploadId)
            ?.addEventListener('change', this.props.onFilesSelect);
    }

    componentWillUnmount(): void {
        document
            .getElementById(this.props.fileUploadId)
            ?.removeEventListener('change', this.props.onFilesSelect);
    }

    render() {
        return (
            <input
                style={{ display: 'none' }}
                type="file"
                name="file"
                accept={SUPPORTED_MR_FORMATS}
                id={this.props.fileUploadId}
                onError={console.error}
                multiple
                className="hidden"
                ref={this.props.onRefChange}
            />
        );
    }
}

export default MRFileSelector;
